import { IHocSinhAce } from "../../../models/response/hoc-sinh/IHocSinhAce";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objHocSinhAceDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IHocSinhAce[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IHocSinhAce | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IHocSinhAce,
    SAVE_SUCESS: {} as IHocSinhAce,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eHocSinhAceActionTypeIds = generateActionTypeIds(objHocSinhAceDefine, "HOC_SINH_ACE")
export type IHocSinhAceActionTypes = IGenericActionType<typeof objHocSinhAceDefine, "HOC_SINH_ACE">
